<template>
  <router-link class="no-underline inline-flex"
               @click.native="resetChoise"
               :to="localizedRoute(route)"
               :title="$t('Home Page')"
  >
    <picture v-if="logoDecoration && Object.keys(logoDecoration).length">
      <source
        media="(min-width: 769px)"
        :srcset="`${logoDecoration.desktop}.webp`"
        width="141"
        height="31"
        type="image/webp"
      >
      <source
        media="(min-width: 769px)"
        :srcset="`${logoDecoration.desktop}.webp`"
        width="141"
        height="31"
        type="image/webp"
      >
      <img
        v-if="(isCheckoutPage || isShopPage) && !isAccountPage && !isCMSPage"
        :src="logoDecoration.mobile"
        :width="width"
        :height="height"
        :alt="storeTitle"
        loading="eager"
        fetchpriority="high"
      >
      <img
        v-else
        :src="`${logoDecoration.desktop}.png`"
        width="141"
        height="31"
        :alt="storeTitle"
        loading="eager"
        fetchpriority="high"
      >
    </picture>
    <picture v-else>
      <source
        media="(min-width: 769px)"
        srcset="/assets/logo-1.webp"
        width="141"
        height="31"
        type="image/webp"
      >
      <source
        media="(min-width: 769px)"
        srcset="/assets/logo-1.png"
        width="141"
        height="31"
        type="image/webp"
      >
      <source
        srcset="/assets/logo-store.webp"
        width="29"
        height="31"
        type="image/webp"
      >
      <img
        v-if="(isCheckoutPage || isShopPage) && !isAccountPage && !isCMSPage"
        src="/assets/logo-store.png"
        width="29"
        height="31"
        :alt="storeTitle"
        loading="eager"
        fetchpriority="high"
      >
      <img
        v-else
        src="/assets/logo-store.png"
        width="29"
        height="31"
        :alt="storeTitle"
        loading="eager"
        fetchpriority="high"
      >
    </picture>
  </router-link>
</template>

<script async>
import { mapGetters, mapActions } from 'vuex';

export default {
  props: {
    width: {
      type: [String, Number],
      required: true
    },
    height: {
      type: [String, Number],
      required: true
    }
  },
  data: () => ({
    meta: {
      title: ''
    }
  }),
  computed: {
    ...mapGetters({
      currentLocation: 'locations/getActiveLocation',
      currentPartner: 'partners/getCurrentPartner',
      getSeasonalDecoration: 'configs/getSeasonalDecoration'
    }),
    route () {
      return this.currentLocation ? `/${this.currentLocation.code}` : '/'
    },
    isThankYouPage () {
      return this.$store.state.checkout.isThankYouPage ? this.$store.state.checkout.isThankYouPage : false
    },
    isCheckoutPage () {
      return this.$route.name === 'checkout'
    },
    isShopPage () {
      return this.currentPartner && this.currentPartner.code !== 'anywhere' && this.currentPartner.display_mode === 'shop'
    },
    isAccountPage () {
      let links = ['my-order', 'my-orders', 'my-account', 'my-shipping-details', 'my-payment-details']
      return links.includes(this.$route.name)
    },
    isCMSPage () {
      let links = ['about-us', 'contacts', 'FAQ', 'umovi-dostavki', 'terms-of-use', 'privacy']
      return links.includes(this.$route.name)
    },
    getDecoration () {
      return this.getSeasonalDecoration && this.getSeasonalDecoration.length ? this.getSeasonalDecoration.find(s => s.value) : {}
    },
    logoDecoration () {
      if (this.getDecoration) {
        return this.getDecoration.key === 'snowflakes'
          ? {desktop: '/assets/logo-new-year', mobile: '/assets/images/icons/new-year-favicon.svg'}
          : {desktop: '/assets/logo-valentine-day', mobile: '/assets/logo-valentine-day-mob.png'}
      }
      return false
    },
    storeTitle () {
      return this.meta.title ? this.meta.title : 'Korzyna.com';
    }
  },
  methods: {
    ...mapActions({
      resetCurrentPartner: 'partners/resetCurrentPartner',
      resetCurrentCategory: 'partner_categories/resetCurrentCategory'
    }),
    // Reset once the home route has rendered - resetting on click blanks the page being left.
    resetChoise () {
      const reset = () => {
        this.resetCurrentPartner()
        this.resetCurrentCategory()
      }
      const target = this.$router.resolve(this.localizedRoute(this.route)).route.path
      if (target === this.$route.path) {
        return reset()
      }
      const unwatch = this.$watch('$route', to => {
        unwatch()
        if (to.path === target) {
          reset()
        }
      })
    }
  },
  mounted () {
    this.$nextTick(() => {
      const metaTag = document.querySelector('meta[property="og:title"]')
      if (metaTag) {
        this.meta.title = metaTag.getAttribute('content');
      }
    })
  }
}
</script>

<style>
picture {
  padding-top: 5px;
}
</style>
